// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import constants from "@store/constants";
import OrderHeader, { OrderHeaderPresentationProps } from "@store/Library/Components/Toolkit/Order/OrderHeader";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import useZoneIsActive from "@toolkit/Framework/Common/Hooks/useZoneIsActive";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC, useContext } from "react";

const zoneName = "ActionButtons";

export interface OrderChangeRequestHeaderPresentationProps extends ExpandStyles<OrderChangeRequestHeaderStyles> {}

export interface OrderChangeRequestHeaderProps extends OrderChangeRequestHeaderPresentationProps {
    contentId?: string;
    step: 1 | 2 | 3;
}

export interface OrderChangeRequestHeaderStyles {
    orderHeader?: OrderHeaderPresentationProps;
}

export const orderChangeRequestHeaderStyles: OrderChangeRequestHeaderStyles = {};

const OrderChangeRequestHeader: FC<OrderChangeRequestHeaderProps> = ({
    contentId = "NONE",
    extendedStyles,
    overridedStyles,
    step,
}) => {
    const styles = useExpandProps(orderChangeRequestHeaderStyles, extendedStyles, overridedStyles);
    const { value: order } = useContext(OrderStateContext);
    const currentPage = useCurrentPage();
    const linkBack = usePageLinkByPageType(constants.pageType.orderDetails);
    const zoneIsActive = useZoneIsActive(zoneName, contentId);
    const orderNumber = order?.erpOrderNumber || order?.webOrderNumber;
    return (
        <OrderHeader
            {...styles.orderHeader}
            title={currentPage.fields.title}
            linkBack={order ? linkBack : undefined}
            pageIdSegment={`?orderNumber=${encodeURIComponent(orderNumber || "")}`}
            progressSteps={constants.progressSteps.orderChangeRequest.map(x => translate(`${x}`))}
            progressActiveStep={step}
            isV2
        >
            {zoneIsActive && <Zone contentId={contentId} zoneName={zoneName} />}
        </OrderHeader>
    );
};

export default OrderChangeRequestHeader;
